import { z } from "zod";
/**
 * The one error shape every REST route in `apps/api` returns.
 *
 *   { "error": { "code": "bad_request", "message": "...", "details": { ... } } }
 *
 * Phase plan S1-4 fixes this envelope in `packages/contracts` so clients and
 * the (Phase 2) admin app can parse failures without per-route special cases.
 * `message` is safe to show to a user only via `packages/i18n` — the server's
 * text is for developers and logs.
 */
export const ERROR_CODES = [
    "bad_request",
    "unauthorized",
    "forbidden",
    "not_found",
    "conflict",
    "rate_limited",
    "unavailable",
    "internal",
];
export const errorCodeSchema = z.enum(ERROR_CODES);
export const errorEnvelopeSchema = z.object({
    error: z.object({
        code: errorCodeSchema,
        message: z.string(),
        details: z.unknown().optional(),
    }),
});
/** HTTP status for each code. The API's error handler is the only caller. */
export const ERROR_STATUS = {
    bad_request: 400,
    unauthorized: 401,
    forbidden: 403,
    not_found: 404,
    conflict: 409,
    rate_limited: 429,
    unavailable: 503,
    internal: 500,
};
export function errorEnvelope(code, message, details) {
    return details === undefined
        ? { error: { code, message } }
        : { error: { code, message, details } };
}
//# sourceMappingURL=error.js.map